import { AxiosProxyConfig } from 'axios';
import storage from '@/renderer/scripts/utils/storage';
import { StoreKey } from '@/renderer/scripts/utils/storage/StoreKey';
interface IProxySetting {
  proxy: 'yes' | 'no';
  proxyAddress: string;
  proxyPort: number;
}
let privateConfig: IProxySetting | null;

/**
 * @description 从storage获取proxy配置，从storage中读取一遍配置项缓存后再返回
 * 若
 * @param disableCache 禁止缓存
 * 若使用了 disableCache 则之前的缓存也会被清除
 *
 */
export const getProxyConfigFromStorage = (disableCache = false): AxiosProxyConfig | false => {
  let storageProxySetting: IProxySetting = privateConfig || storage.get<IProxySetting>(StoreKey.PROXY_SETTING);
  if (disableCache) {
    storageProxySetting = storage.get<IProxySetting>(StoreKey.PROXY_SETTING);
  }
  privateConfig = storageProxySetting;
  return storageProxySetting?.proxy === 'yes'
    ? {
        host: storageProxySetting.proxyAddress,
        port: storageProxySetting.proxyPort,
      }
    : false;
};
